import {useCheckoutRoute} from '@aboutyou/router';
import {useCallback} from 'react';
import {useHistoryPush} from './useHistoryPush';

export const useGoToCheckoutCallback = () => {
  const historyPush = useHistoryPush();
  const checkoutRoute = useCheckoutRoute();

  return useCallback(() => {
    historyPush(checkoutRoute);
  }, [checkoutRoute, historyPush]);
};
